import { Injectable, inject } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';


export interface ShopConfiguration {
  name: string;
  logoColorDesktop: {
    url: string;
  };
  logoColorMobile: {
    url: string;
  };
  logoWhite: {
    url: string;
  };
  thumbnail: {
    url: string;
  };
  mainColorNormal: string;
  mainColorLight: string;
  mainColorDark: string;
  secondaryColorNormal: string;
  secondaryColorLight: string;
  secondaryColorDark: string;
  allowGuestOrder: boolean;
  simpleReturn: boolean;
  simpleRefund: boolean;
  showSelectedForYou: boolean;
  showLandingCourier: boolean;
  showLandingCustomProducts: boolean;
  version: number;
}

@Injectable({
  providedIn: 'root',
})
export class ShopService {
  private readonly http = inject(HttpClient);

  public getShopConfiguration(): Observable<ShopConfiguration> {
    return this.http.get('shop/configuration').pipe(
      map((data: ShopConfiguration) => {
        return data;
      }),
      tap());
  }
}
